// Import from NPM
// -------------------------------------
import React, { useState } from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { clientAssetsPath, useGetCourseBuilderQuery } from "@api/apiV6";
import { useDeleteCourseMutation } from "@api/apiV6";

import { Div, Image } from "@components/Generics.react";
import "@styles/navbars.scss";

import { Loader, Icon, Confirm } from "semantic-ui-react";
import ActionCard from "@components/ActionCard.react";
import PreviewLayout from "@layouts/PreviewLayout.react";

export default function CourseView(props) {
    const { id } = props;
    const { data: course, isSuccess } = useGetCourseBuilderQuery(id);

    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [deleteCourse] = useDeleteCourseMutation();

    const { t } = useTranslation("common");

    function doDelete() {
        const storedRecents = window.localStorage.getItem("libraryRecents");
        let libraryRecents = [];
        if (storedRecents) {
            libraryRecents = JSON.parse(storedRecents);
        }
        _.remove(libraryRecents, {
            key: course._id,
        });
        window.localStorage.setItem(
            "libraryRecents",
            JSON.stringify(libraryRecents)
        );
        deleteCourse(course._id);
    }

    const actionMap = {
        setup: `/builder/courses/${course?._id}/setup`,
        edit: `/builder/courses/${course?._id}/editor`,
        learners: `/builder/courses/${course?._id}/learners`,
        analytics: `/builder/analytics/${course?._id}/analytics`,
    };

    // ========================= Render Function =================================
    return isSuccess ? (
        <Div flex noWrap spaceAround fullht padTop padSides>
            <Div basepad txtCharcoal fullht autoOverflowY>
                <Div flex spaceBetween gapped>
                    <Div
                        fullht
                        wd="15px"
                        ht="175px"
                        style={{ background: "#800080" }}
                    />
                    <Div wd="calc(100% - 30px)">
                        <Div
                            float-right
                            big
                            clickable
                            style={{ marginTop: "15px" }}
                        >
                            <Icon
                                bordered
                                color="red"
                                inverted
                                circular
                                name="trash"
                                onClick={() => setDeleteConfirm(true)}
                            />
                        </Div>
                        <Div uppercase>
                            {t("components.edit")} {t("components.course")}:
                        </Div>
                        <Div massive altText uppercase gutter>
                            {course.name}
                        </Div>
                        <Div>
                            <Div wd="150px" float-left padRight>
                                <Image
                                    src={`${clientAssetsPath}/uploads/images/course/${
                                        course?._id
                                    }.${course?.image
                                        ?.split(".")
                                        .pop()
                                        .toLowerCase()}`}
                                    snubbed
                                />
                            </Div>
                            <Div padded>{course.description}</Div>
                        </Div>
                    </Div>
                </Div>
                <Div clear maxWd="460px">
                    <br />
                    <Div basepad ash snubbed>
                        {_.map(_.keys(actionMap), (act, idx) => (
                            <ActionCard
                                key={`${course._id}-action-${idx}`}
                                icon={t(
                                    `builder.viewPanels.course.${act}.icon`
                                )}
                                header={t(
                                    `builder.viewPanels.course.${act}.header`
                                )}
                                content={t(
                                    `builder.viewPanels.course.${act}.content`
                                )}
                                link={actionMap[act]}
                            />
                        ))}
                    </Div>
                </Div>
            </Div>
            <PreviewLayout
                url={`/courses/${course.id}`}
                message={
                    course.wrapper &&
                    course.wrapper !== "none" &&
                    t("builder.dic.previewHelp")
                }
            />
            <Confirm
                open={deleteConfirm}
                onCancel={() => setDeleteConfirm(false)}
                onConfirm={() => {
                    doDelete();
                    setDeleteConfirm(false);
                    toast(t("builder.course.deleted"));
                }}
            />
        </Div>
    ) : (
        <Loader active inverted />
    );
}
